export const defaultValues = {
  email: '',
  reportRecipients: [],
  reportIncludeUserId: false,
  reportIncludedItemName: '',
  reportIncludedActivityName: '',
  subject: '',
  reportServerIp: '',
  reportPublicKey: '',
};

export const OK_MESSAGE = 'ok';
export const SUCCESS_MESSAGE = 'success';

export const REPORT_SERVER_INSTRUCTIONS_LINK =
  'https://github.com/ChildMindInstitute/mindlogger-report-server';
